import "./carrier-rule-actions-cell.css";

import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import type { GridCustomCellProps } from "@tql/ui-components-react/kendo/grid";
import { trashIcon } from "@tql/ui-components-react/kendo/svg-icons";

import { GridTd } from "~/shared/components/trax-grid/grid-td/grid-td.tsx";

import type { CarrierRule } from "../../../modal/utils/types.ts";

type CarrierRuleActionsCellProps = GridCustomCellProps & {
	handleRemoveRow: (id: number) => void;
	cellTestId?: string;
};

export const CarrierRuleActionsCell = ({
	handleRemoveRow,
	...props
}: CarrierRuleActionsCellProps) => (
	<GridTd data-testid={props.cellTestId} tdProps={props.tdProps}>
		<button
			aria-label={"Remove Carrier Rule"}
			className={"carrier-rule-actions-button"}
			onClick={() => handleRemoveRow((props.dataItem as CarrierRule).id)}
			type={"button"}
		>
			<SvgIcon icon={trashIcon} />
		</button>
	</GridTd>
);
